import { t } from 'i18next';
import {
  ValidationSet,
  WithoutIncomeChildI,
  WithoutIncomeFamilyI
} from '../../../../../types/interface';
import {
  capitalizeFirstLetter,
  formatDateOnly,
  isFieldEmptyAndInOverview
} from 'utils/helpers';
import ConditionalRender from 'base/ConditionalRender/ConditionalRender';
import StandardInput from 'base/StandardInput/StandardInput';
import { StandardImageUpload } from 'base/StandardImageUpload/StandardImageUpload';
import StandardCheckbox from 'base/StandardCheckbox/StandardCheckbox';

export const WithoutIncome = ({
  formDataChildren,
  formDataFamily
}: {
  formDataFamily: WithoutIncomeFamilyI[];
  formDataChildren: WithoutIncomeChildI[];
}) => {
  const disabled = true;
  const showError = false;
  const handleChangeFamily = (
    a: number,
    b: keyof WithoutIncomeFamilyI,
    c: any
  ) => {
    console.log(a, b, c);
  };
  const handleChangeChildren = (
    a: number,
    b: keyof WithoutIncomeChildI,
    c: any
  ) => {
    console.log(a, b, c);
  };
  const WithoutHouseholdFamilyValidationsSet: ValidationSet<WithoutIncomeFamilyI> =
    {
      first_name: [],
      last_name: [],
      birth_date: [],
      zip_code: [],
      location: [],
      federal_state: [],
      basic_data_type: [],
      includes_income_details: [],
      street: [],
      registration_form_file: [],
      net_income_eur: [],
      pay_slip_file: [],
      pay_slip_date_proof: [],
      pension_notice_file: [],
      pension_notice_date_proof: [],
      confirmation_of_co_insurance_file: [],
      confirmation_of_co_insurance_date_proof: [],
      additional_income_eur: [],
      proof_of_income_or_income_tax_notice_file: [],
      proof_of_income_or_income_tax_notice_date_proof: [],
      has_children: [],
      childcare_allowance_eur: [],
      family_bonus_eur: [],
      proof_of_child_allowance_file: [],
      proof_of_child_allowance_date_proof: [],
      parent_seprately: [],
      is_disability: [],
      proof_of_disability_file: [],
      birth_certificate_file: []
    };
  const WithoutHouseholdChildrenValidationsSet: ValidationSet<WithoutIncomeChildI> =
    {
      first_name: [],
      last_name: [],
      net_income_eur: [],
      birth_certificate_file: [],
      birth_certificate_date_proof: [],
      basic_data_type: [],
      includes_income_details: [],
      proof_of_income_file_id: [],
      proof_of_income_file: [],
      proof_of_income_date_proof: [],
      basic_military_community_service_file: [],
      basic_military_community_service_date_proof: [],
      confirmation_of_co_insurance_file: [],
      confirmation_of_co_insurance_date_proof: [],
      school_study_confirmation_file: [],
      school_study_confirmation_date_proof: [],
      number_of_children: [],
      childcare_allowance_eur: [],
      family_bonus_eur: [],
      proof_of_child_allowance_file: [],
      proof_of_child_allowance_date_proof: [],
      parent_live_separately: [],
      alimony_amount: [],
      received: [],
      paid: [],
      alimentation_payment_file: [],
      alimentation_payment_date_proof: [],
      decision_file: [],
      decision_date_proof: [],
      is_disability: [],
      proof_of_disability_file: []
    };
  return (
    <div id="without_household">
      <div className="container-fluid ">
        <ConditionalRender
          condition={formDataFamily.length > 0 || formDataChildren.length > 0}
        >
          <div className="row">
            <div className="col-12 my-3">
              <h1 className="text-center">
                {capitalizeFirstLetter(t('overview.general.text_4'))}
              </h1>
            </div>
            <div
              className="col-12 col-xl-6 px-4 px-lg-4"
              id="without_income_family"
            >
              {formDataFamily.map((item, index) => {
                return (
                  <div
                    key={`without-household-family-${index}`}
                    className={`mb-3`}
                  >
                    <ConditionalRender condition={index !== 0}>
                      <div className="row mb-2 d-flex align-items-center">
                        <div className="col-12">
                          <hr />
                        </div>
                        <h4 className="col-11 fs-16 font-bold text-center">
                          {capitalizeFirstLetter(
                            t('basic_data.without_income.general.text_4')
                          )}
                        </h4>
                      </div>
                      <div className="row">
                        <StandardInput
                          type="text"
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.first_name
                          )} form-control-icon col-12 col-md-4`}
                          disabled={disabled}
                          placeholder={t('general.common_text.text_5')}
                          label={t('general.common_text.text_5')}
                          value={item.first_name}
                          showError={showError}
                          onChange={(e: any) =>
                            handleChangeFamily(index, 'first_name', e)
                          }
                          validations={
                            WithoutHouseholdFamilyValidationsSet?.first_name
                          }
                        />
                        <StandardInput
                          type="text"
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.last_name
                          )} form-control-icon col-12 col-md-4`}
                          disabled={disabled}
                          placeholder={t('general.common_text.text_6')}
                          label={t('general.common_text.text_6')}
                          value={item.last_name}
                          showError={showError}
                          onChange={(e: any) => {
                            handleChangeFamily(index, 'last_name', e);
                          }}
                          validations={
                            WithoutHouseholdFamilyValidationsSet?.last_name
                          }
                        />
                        <StandardInput
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.birth_date
                          )} form-control-icon col-12 col-md-4`}
                          disabled={disabled}
                          placeholder={t(
                            'register_applicant.placeholder.birthDate'
                          )}
                          value={formatDateOnly(item.birth_date)}
                          showError={showError}
                          onChange={(e: any) => {
                            handleChangeFamily(index, 'birth_date', e);
                          }}
                          validations={
                            WithoutHouseholdFamilyValidationsSet?.birth_date
                          }
                          label={t('register_applicant.placeholder.birthDate')}
                          type=""
                        />
                      </div>
                      <div className="row">
                        <StandardInput
                          type="text"
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.street
                          )} form-control-icon`}
                          placeholder={t(
                            'register_applicant.placeholder.street'
                          )}
                          disabled={disabled}
                          label={t('register_applicant.placeholder.street')}
                          value={item.street}
                          showError={showError}
                          onChange={(e: any) => {
                            handleChangeFamily(index, 'street', e);
                          }}
                          validations={
                            WithoutHouseholdFamilyValidationsSet?.street
                          }
                        />
                      </div>
                      <div className="row">
                        <StandardInput
                          type="text"
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.zip_code
                          )} form-control-icon col-12 col-md-6`}
                          disabled={disabled}
                          placeholder={t(
                            'basic_data.without_income.left.placeholder.PLZ(Private)'
                          )}
                          label={t(
                            'basic_data.without_income.left.placeholder.PLZ(Private)'
                          )}
                          showError={showError}
                          maxLength={4}
                          onChange={(e: any) => {
                            handleChangeFamily(index, 'zip_code', e);
                          }}
                          validations={
                            WithoutHouseholdFamilyValidationsSet?.zip_code
                          }
                          value={item.zip_code as string}
                        />
                        <StandardInput
                          type="text"
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.location
                          )} form-control-icon col-12 col-md-6`}
                          placeholder={t(
                            'basic_data.without_income.left.placeholder.Ort (Privat)'
                          )}
                          disabled={disabled}
                          label={t(
                            'basic_data.without_income.left.placeholder.Ort (Privat)'
                          )}
                          value={item.location}
                          showError={showError}
                          onChange={(e: any) => {
                            handleChangeFamily(index, 'location', e);
                          }}
                          validations={
                            WithoutHouseholdFamilyValidationsSet?.location
                          }
                        />
                      </div>
                      <div className="row">
                        <div className="col-12 col-md-6">
                          <StandardImageUpload
                            className={`${isFieldEmptyAndInOverview(
                              true,
                              !!item.registration_form_file
                            )} col-12`}
                            value={item.registration_form_file}
                            disabled={!disabled}
                            imageText={t(
                              'basic_data.without_income.left.attachment.text_1'
                            )}
                            showError={showError}
                            validations={
                              WithoutHouseholdFamilyValidationsSet?.registration_form_file
                            }
                            label={t(
                              'basic_data.without_income.left.attachment.text_1'
                            )}
                          />
                        </div>
                      </div>
                    </ConditionalRender>
                  </div>
                );
              })}
            </div>
            <div
              className="col-12 col-xl-6 px-4 px-lg-4"
              id="without_income_children"
            >
              <div className="row">
                <StandardCheckbox
                  disabled={true}
                  isChecked={formDataChildren.length > 0}
                  setChecked={() => {}}
                  className="checkbox-margin-class ms-0"
                  label={t('basic_data.without_income.general.text_0')}
                />
              </div>
              {formDataChildren.map((item, index) => {
                return (
                  <div
                    key={`without-household-children-${index}`}
                    className={`mb-3`}
                  >
                    <div className="row font-bold fs-16">
                      <div className="col-12">
                        <hr />
                      </div>
                      <div className="col-11 d-flex justify-content-center mb-2">
                        <ConditionalRender
                          condition={!!item.live_separately}
                          fallBack={
                            <h4>
                              {t(
                                'household_income_calculator.calculator.members.field_2'
                              )}
                            </h4>
                          }
                        >
                          <h4>
                            {t(
                              'basic_data.with_income.live_saperately_heading'
                            )}
                          </h4>
                        </ConditionalRender>
                      </div>
                    </div>
                    <div className="row">
                      <StandardInput
                        disabled={disabled}
                        type="text"
                        className={`col-12 ${isFieldEmptyAndInOverview(
                          true,
                          !!item.first_name
                        )} ${item.live_separately ? 'col-md-6' : 'col-md-4'}`}
                        placeholder={t('general.common_text.text_5')}
                        label={t('general.common_text.text_5')}
                        value={item.first_name}
                        showError={showError}
                        onChange={(e: any) => {
                          handleChangeChildren(index, 'first_name', e);
                        }}
                        validations={
                          WithoutHouseholdChildrenValidationsSet?.first_name
                        }
                      />
                      <StandardInput
                        type="text"
                        className={`col-12 ${isFieldEmptyAndInOverview(
                          true,
                          !!item.last_name
                        )} ${item.live_separately ? 'col-md-6' : 'col-md-4'}`}
                        disabled={disabled}
                        placeholder={t('general.common_text.text_6')}
                        label={t('general.common_text.text_6')}
                        value={item.last_name}
                        showError={showError}
                        onChange={(e: any) => {
                          handleChangeChildren(index, 'last_name', e);
                        }}
                        validations={
                          WithoutHouseholdChildrenValidationsSet?.last_name
                        }
                      />
                      <StandardInput
                        className={`${isFieldEmptyAndInOverview(
                          true,
                          !!item.birth_date
                        )} form-control-icon col-12 col-md-4`}
                        disabled={disabled}
                        placeholder={t(
                          'register_applicant.placeholder.birthDate'
                        )}
                        label={t('register_applicant.placeholder.birthDate')}
                        value={formatDateOnly(item.birth_date as string)}
                        showError={showError}
                        onChange={(e: any) => {
                          handleChangeChildren(index, 'birth_date', e);
                        }}
                        validations={
                          WithoutHouseholdChildrenValidationsSet?.birth_date as any
                        }
                        type=""
                      />
                    </div>
                    <div className="row">
                      <StandardInput
                        type="text"
                        className={`${isFieldEmptyAndInOverview(
                          true,
                          !!item.street
                        )} form-control-icon`}
                        placeholder={t('register_applicant.placeholder.street')}
                        disabled={disabled}
                        label={t('register_applicant.placeholder.street')}
                        value={item.street as string}
                        showError={showError}
                        onChange={(e: any) => {
                          handleChangeChildren(index, 'street', e);
                        }}
                        validations={
                          WithoutHouseholdChildrenValidationsSet?.street as any
                        }
                      />
                    </div>
                    <div className="row">
                      <StandardInput
                        type="text"
                        className={`${isFieldEmptyAndInOverview(
                          true,
                          !!item.zip_code
                        )} form-control-icon col-12 col-md-6`}
                        disabled={disabled}
                        placeholder={t(
                          'basic_data.without_income.left.placeholder.PLZ(Private)'
                        )}
                        label={t(
                          'basic_data.without_income.left.placeholder.PLZ(Private)'
                        )}
                        value={item.zip_code as string}
                        showError={showError}
                        maxLength={4}
                        onChange={(e: any) => {
                          handleChangeChildren(index, 'zip_code', e);
                        }}
                        validations={
                          WithoutHouseholdChildrenValidationsSet?.zip_code as any
                        }
                      />
                      <StandardInput
                        type="text"
                        className={`${isFieldEmptyAndInOverview(
                          true,
                          !!item.location
                        )} form-control-icon col-12 col-md-6`}
                        placeholder={t(
                          'basic_data.without_income.left.placeholder.Ort (Privat)'
                        )}
                        disabled={disabled}
                        label={t(
                          'basic_data.without_income.left.placeholder.Ort (Privat)'
                        )}
                        value={item.location as string}
                        showError={showError}
                        onChange={(e: any) => {
                          handleChangeChildren(index, 'location', e);
                        }}
                        validations={
                          WithoutHouseholdFamilyValidationsSet?.location
                        }
                      />
                    </div>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <StandardImageUpload
                          className={isFieldEmptyAndInOverview(
                            true,
                            !!item.birth_certificate_file
                          )}
                          value={item.birth_certificate_file}
                          disabled={!disabled}
                          imageText={t(
                            'basic_data.without_income.right.attachment.text_2'
                          )}
                          showError={showError}
                          validations={
                            WithoutHouseholdChildrenValidationsSet?.birth_certificate_file
                          }
                          label={t(
                            'basic_data.without_income.right.attachment.text_2'
                          )}
                        />
                      </div>
                      <StandardInput
                        className={`${isFieldEmptyAndInOverview(
                          true,
                          !!item.birth_date
                        )} col-12 col-md-6`}
                        disabled={disabled}
                        placeholder={t(
                          'register_applicant.placeholder.birthDate'
                        )}
                        label={t('register_applicant.placeholder.birthDate')}
                        value={formatDateOnly(item.birth_date as string)}
                        showError={showError}
                        onChange={(e: any) => {
                          handleChangeChildren(index, 'birth_date', e);
                        }}
                        validations={
                          WithoutHouseholdChildrenValidationsSet?.birth_date as any
                        }
                        type=""
                      />
                      <div className="col-12 col-md-6">
                        <StandardImageUpload
                          className={isFieldEmptyAndInOverview(
                            true,
                            !!item.registration_form_file
                          )}
                          value={item.registration_form_file!}
                          disabled={!disabled}
                          imageText={t(
                            'basic_data.without_income.left.attachment.text_1'
                          )}
                          showError={showError}
                          validations={
                            WithoutHouseholdChildrenValidationsSet?.registration_form_file
                          }
                          label={t(
                            'basic_data.without_income.left.attachment.text_1'
                          )}
                        />
                      </div>
                    </div>
                    <ConditionalRender condition={!!item.live_separately}>
                      <div className="row">
                        <StandardImageUpload
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.family_benefits_file
                          )} form-control-icon col-12 col-md-6`}
                          value={item.family_benefits_file!}
                          disabled={!disabled}
                          imageText={t(
                            'basic_data.with_income.placeholder.text_28'
                          )}
                          showError={
                            item.family_benefits_date_proof ? showError : false
                          }
                          validations={
                            item.family_benefits_date_proof
                              ? WithoutHouseholdChildrenValidationsSet?.family_benefits_file
                              : undefined
                          }
                          label={t(
                            'basic_data.with_income.placeholder.text_28'
                          )}
                        />
                        <StandardInput
                          className={`${isFieldEmptyAndInOverview(
                            true,
                            !!item.family_benefits_date_proof
                          )} form-control-icon col-12 col-md-6`}
                          disabled={disabled}
                          placeholder={t(
                            'basic_data.with_income.placeholder.text_27'
                          )}
                          value={formatDateOnly(
                            item.family_benefits_date_proof as Date
                          )}
                          onChange={(e: any) => {
                            handleChangeChildren(
                              index,
                              'family_benefits_date_proof',
                              e
                            );
                          }}
                          showError={
                            item.family_benefits_file ? showError : false
                          }
                          validations={
                            item.family_benefits_file
                              ? WithoutHouseholdChildrenValidationsSet.family_benefits_date_proof
                              : ([] as any)
                          }
                          label={t(
                            'basic_data.with_income.placeholder.text_27'
                          )}
                          type=""
                        />
                      </div>
                    </ConditionalRender>
                  </div>
                );
              })}
            </div>
          </div>
        </ConditionalRender>
      </div>
    </div>
  );
};
